import React from 'react';
//import { makeStyles } from "@mui/styles";
import {Card, CardContent, Typography, Grid, CardHeader} from "@mui/material";
//import ASPECStyles from "../../../../../styles/jss/components/apps/ASPECStyles";
import {statusColor} from "../../../../../helpers";
import {useTheme} from "@mui/material/styles";
import { toast } from 'react-toastify';
import EditName from "../successfulAnalysis/EditName";
import Reference from "../Reference";

//const useStyles = makeStyles(ASPECStyles);

const AnalysisDetails = props => {
    //const classes = useStyles();
    const theme = useTheme();
    const {updateData} = props;

    const [name, setName] = React.useState('');
    const [nameError, setNameError] = React.useState(false);

    React.useEffect(() => {
        setName(props.name)
    }, [props.name])

    const handleNameChange = e => {
        let value = e.target.value;
        setNameError(false);
        if(value.length > 30) {
            toast.warning('Cannot have a name over 30 characters', 'WARNING', 2000)
        }
        if(value.length === 0) {
            setNameError(true)
            toast.warning('Cannot have a whitespace name.', 'WARNING')
        }
        setName(value.slice(0,30))
    }

    const sanitizeDate = d => {
      if (d instanceof Date) {
        return !isNaN(d) ? d : "";
      }
      return d
    }

    return(
        <Card style={{height: '100%'}}>
            <CardHeader
                title={'Project Details'}
                sx={{
                  "&": {
                    padding: '16px 16px 0 16px',
                    alignItems: 'flex-start'
                  }
                }}
                slotProps={{
                  title: {
                    fontSize: '20px'
                  }
                }}
                // classes={{
                //     title: classes.cardHeaderTitle,
                //     root: classes.cardHeaderRoot
                // }}
                action={
                    <Reference refs={props.refs} aircraft={props.project.aircraft} />
                }
            />
            <CardContent sx={{padding: '0, 16px, 16px, 16px'}}>
                <Grid container spacing={2}>
                    <Grid size={{ md: 3 }}>
                        <Typography variant={'caption'}>Project Name:</Typography>
                        <Typography variant={'body2'}>{props.project.name}</Typography>
                    </Grid>
                    <Grid size={{ md: 3 }}>
                        <Typography variant={'caption'}>Aircraft:</Typography>
                        <Typography variant={'body2'}>{props.project.aircraft?.toUpperCase() ?? ""}</Typography>
                    </Grid>
                    <Grid size={{ md: 6 }}>
                        <EditName name={props.name} update={updateData} />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid size={{ md: 3 }}>
                        <Typography variant={'caption'}>Run Date:</Typography>
                        <Typography variant={'body2'}>{sanitizeDate(props.run)}</Typography>
                    </Grid>
                    <Grid size={{ md: 3 }}>
                        <Typography variant={'caption'}>Status</Typography>
                        <Typography style={{color: statusColor(props.status, theme)}} variant={'body2'}>{props.status}</Typography>
                    </Grid>
                </Grid>

            </CardContent>
        </Card>
    )
}

export default AnalysisDetails;